"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MigrateToHoldingView = void 0;
class MigrateToHoldingView {
    constructor(holdingRepository) {
        this.holdingRepository = holdingRepository;
    }
    execute(request) {
        return this.holdingRepository.migrateToHoldingView(request);
    }
}
exports.MigrateToHoldingView = MigrateToHoldingView;
